import { FixedLeftMenu } from '../../components';
import { connect } from 'react-redux';
import { rolesToMenuItems } from '../../helpers';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  actions: state.auth.user && state.auth.user.roles ? rolesToMenuItems(state.auth.user.roles) : [],
})

const mapDispatchToProps = { };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FixedLeftMenu));



// WEBPACK FOOTER //
// ./src/Layouts/MainLayout/FixedLeftMenuConnected.js